import React from 'react'
import { Rect, Text } from 'react-konva'
import { icons, colors } from 'assets'
import { EventIconProps } from './types'
import { VideoEventTypes } from 'models'

const EventIcon = (props: EventIconProps) => {
  const {
    x, y, width, height, eventAtCurrentFrame
  } = props

  const getIcon = () => {
    const { type } = eventAtCurrentFrame

    switch (type) {
      case VideoEventTypes.IN: return icons.inPoint
      case VideoEventTypes.OUT: return icons.outPoint
      default: return icons.anchor
    }
  }

  return eventAtCurrentFrame
    ? (
      <>
        <Rect
          x={x + width - 28}
          y={y + height - 28}
          width={25}
          height={25}
          fill={colors.black}
          cornerRadius={3}
        />
        <Text
          x={x + width - 28}
          y={y + height - 20}
          width={25}
          height={25}
          fill='white'
          fontFamily='Glyph'
          fontSize={16}
          text={getIcon()}
          align='center'
          verticalAlign='center'
        />
      </>
    )
    : null
}

export default EventIcon
